import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class powerbi
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.powerbi = {};

/**
 * Gets Token for the powerbi widget
 * @param {ReachAPI.Security} security
 * @param {number} widgetId
 * @throws {ReachApiError}
 * @returns {Promise<ReachApiResponse>}
 * @memberof ReachAPI.powerbi
 */
ReachAPI.powerbi.getToken = function (security, widgetId) {
    // var cacheId = "/signage/powerbi/account/" + widgetId;
    var url = ReachAPI.server + '/signage/powerbi/token/' + widgetId;
    var params = {};
    var jqPromise;

    if (security.token) {
        params.token = security.token;
    } else {
        params.uuid = security.player_uuid;
    }

    jqPromise = ReachAPI.getWithFallback(url, 'json', params);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Info(
                'Retrieved powerbi account data from the CACHE (API call failed). Widget rendering will most likely fail.',
                null,
                __fileline
            );
        } else {
            Log.Debug('Retrieved account data from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve powerbi account data',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return ReachAPI.deferredToPromise(jqPromise);
};
